import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './ServiceSlider.css';

const slides = [
  {
    id: 'web',
    image: '/images/slide-inventory.png',
    eyebrow: 'Web applications',
    title: 'Inventory & operations dashboards',
    text: '.NET and PHP platforms for stock control, warehouses, admin portals, and the APIs that keep every location in sync.',
    to: '/services#web',
    cta: 'Explore web services',
  },
  {
    id: 'mobile',
    image: '/images/slide-mobile-app.png',
    eyebrow: 'Mobile products',
    title: 'iOS & Android apps for the field',
    text: 'Native Swift and Kotlin apps, plus Flutter, React Native, or .NET MAUI, for tracking, approvals, and customer workflows on the go.',
    to: '/services#mobile',
    cta: 'Explore mobile services',
  },
  {
    id: 'digital',
    image: '/images/slide-analytics.png',
    eyebrow: 'Digital growth',
    title: 'SEO, ads and lifecycle email',
    text: 'Campaign and analytics programs that sit on top of the product we build, so traffic turns into signed-in usage, not just visits.',
    to: '/services#digital',
    cta: 'Explore digital services',
  },
];

const ServiceSlider = () => {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return undefined;
    const timer = setInterval(() => {
      setIndex((current) => (current + 1) % slides.length);
    }, 6500);
    return () => clearInterval(timer);
  }, [paused]);

  const goTo = (next) => {
    setIndex((next + slides.length) % slides.length);
  };

  const slide = slides[index];

  return (
    <section
      className="service-slider section"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div className="container">
        <p className="eyebrow" style={{ display: 'block', textAlign: 'center' }}>Selected work</p>
        <h2 className="section-title">Product surfaces we ship</h2>
        <p className="section-subtitle">
          Real application UI: web dashboards, mobile clients, and growth analytics, not abstract artwork.
        </p>

        <div className="slider-frame" aria-roledescription="carousel" aria-label="Service highlights">
          <div className="slider-media">
            <img src={slide.image} alt={slide.title} />
          </div>
          <div className="slider-copy">
            <p className="eyebrow">{slide.eyebrow}</p>
            <h3>{slide.title}</h3>
            <p>{slide.text}</p>
            <Link to={slide.to} className="btn btn-primary">{slide.cta}</Link>
          </div>

          <button className="slider-nav prev" type="button" onClick={() => goTo(index - 1)} aria-label="Previous slide">
            ‹
          </button>
          <button className="slider-nav next" type="button" onClick={() => goTo(index + 1)} aria-label="Next slide">
            ›
          </button>
        </div>

        <div className="slider-dots" role="tablist" aria-label="Choose a service slide">
          {slides.map((item, i) => (
            <button
              key={item.id}
              type="button"
              className={`slider-dot ${i === index ? 'active' : ''}`}
              onClick={() => setIndex(i)}
              aria-label={item.title}
              aria-current={i === index ? 'true' : undefined}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceSlider;
